import { toast } from "react-hot-toast";

const OFFLINE_TOAST_ID = "offline-toast";

export function showOfflineToast(message: string) {
  toast.dismiss();

  toast.error(message, {
    id: OFFLINE_TOAST_ID,
    duration: Infinity,
  });
}

export function hideOfflineToast() {
  toast.dismiss(OFFLINE_TOAST_ID);
}
